/**
 * @file: OrgUserRoleType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum OrgUserRoleType {
  Administrator = 'admin',
  Technicians = 'tech',
  ServiceAgents = 'service_agent',
  Manager = 'manager',
  AgentManager = 'agent_manager',
  Quoter = 'quoter',
  Financial = 'financial',
  QualityInspector = 'quality_inspector',
  Marketer = 'marketer',
}

export const OrgUserRoleTypeValueSet = new Set([
  OrgUserRoleType.Administrator,
  OrgUserRoleType.Technicians,
  OrgUserRoleType.ServiceAgents,
  OrgUserRoleType.Manager,
  OrgUserRoleType.AgentManager,
  OrgUserRoleType.Quoter,
  OrgUserRoleType.Financial,
  OrgUserRoleType.QualityInspector,
  OrgUserRoleType.Marketer,
]);
